import {
  baseLocale,
  defineCustomClientStrategy,
  extractLocaleFromNavigator,
  getLocale,
  overwriteGetLocale,
  type Locale,
} from "$lib/paraglide/runtime";
import { getProducts } from "$lib/products";
import type { ClientInit } from "@sveltejs/kit";

export const init: ClientInit = async () => {
  await getProducts().catch((err) => console.error("Failed to prefetch products", err));
}

const LANGUAGE_STORAGE_KEY = "lang";

overwriteGetLocale(
  () => (localStorage.getItem(LANGUAGE_STORAGE_KEY) ?? extractLocaleFromNavigator() ?? baseLocale) as Locale
);

defineCustomClientStrategy("custom-localStorage", {
  getLocale: getLocale,
  setLocale: (locale: Locale) => localStorage.setItem(LANGUAGE_STORAGE_KEY, locale),
});
